export default __webpack_public_path__ + "static/media/E07.9008775e.mp3";